import InfoBlocks from "./InfoBlocks";

export default InfoBlocks;
